import EditTemplate from "components/atoms/WebsiteBuilders/EditTemplate";
import React from "react";

const Template = () => {
    return <EditTemplate />;
};

export default Template;
